export enum ApplymentWindowType {
    Online = 1,
    InPerson
}
